import { BooleanInput, coerceBooleanProperty } from "@angular/cdk/coercion";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface NoResultsTemplateComponentState {
    areFiltersApplied: boolean;
    title: string | undefined;
}

@Component({
    selector: "dtm-ui-no-results",
    templateUrl: "./no-results.component.html",
    styleUrls: ["./no-results.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class NoResultsComponent {
    @Input() public set areFiltersApplied(value: BooleanInput) {
        this.localStore.patchState({ areFiltersApplied: coerceBooleanProperty(value) });
    }

    @Input() public set title(value: string | undefined) {
        this.localStore.patchState({ title: value });
    }

    public readonly title$ = this.localStore.selectByKey("title");
    public readonly areFiltersApplied$ = this.localStore.selectByKey("areFiltersApplied");

    constructor(private readonly localStore: LocalComponentStore<NoResultsTemplateComponentState>) {
        localStore.setState({ areFiltersApplied: false, title: undefined });
    }
}
